import React, {useEffect, useState} from "react";
import {
    Button,
    FormRadio,
    FormTextarea,
    Modal,
    ModalBody,
    ModalHeader
} from "shards-react";
import { FormCheckbox } from "shards-react";
import { requests } from "../../../api/request";
import * as status from '../SelectList/Status';
import * as missingDocuments from "../SelectList/MissingDocuments";
import * as modalChoice from "../SelectList/ModalChoice";
import moment from "moment";

const ModalNotifications = ({
    sendDataRaise,
    appointmentId,
    patient,
    practitioner,
    allowAccess
}) => {
    const [open, setOpen] = useState(false);
    const [modalType, setModalType] = useState(null);
    const [selectedDocuments, setSelectedDocuments] = useState([]);
    const [otherReason, setOtherReason] = useState('');
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [rowRaisedDoneSaved, setRowRaisedDoneSaved] = useState([]);

    useEffect(() => {
        const raiseData = JSON.parse(localStorage.getItem("rowRaiseDone"));
        setRowRaisedDoneSaved(raiseData || []);
    }, []);

    function generateIconStyles(active, fontSize = '', color = '') {
        return {
            fontSize : active ? fontSize : '',
            color: active ? color : ''
        };
    }

    const raiseByPhone = () => {
        const formattedDate = moment().format('DD/MM/YYYY [à] HH[h]mm');
        sendDataRaise(formattedDate, appointmentId, modalType);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = {};
        data.appointmentId = appointmentId;
        const statusTerminated = [];
        const reasons = [];

        if (
            selectedStatus === status.NEW_BY_PATIENT ||
            selectedStatus === status.CANCELLED_BY_PATIENT ||
            selectedStatus === status.TERMINATED ||
            selectedStatus === status.CLOSED
        ) {
            data.template = 'Practitioner';
            reasons.push(selectedStatus);
            data.reasons = reasons;
        }
        if (
            selectedStatus === status.CONFIRMED ||
            selectedStatus === status.NEW_BY_PRACTITIONER ||
            selectedStatus === status.CANCELLED_BY_PRACTITIONER
        ) {
            data.template = 'Patient';
            reasons.push(selectedStatus);
            data.reasons = reasons;
        }

        for (const document of selectedDocuments) {
            if (
                document === missingDocuments.SIKE_LEAVE ||
                document === missingDocuments.WORK_LEAVE ||
                document === missingDocuments.MEDICAL_CLAIM_FORM
            ) {
                statusTerminated.push(document);
            }
        }

        if (statusTerminated.length !== 0) {
            data.reasons = { missingDocuments: statusTerminated };
            data.template = 'DocumentMissing';
        }

        if (otherReason) {
            const otherReasons = { label: otherReason };
            data.template = 'DocumentMissing';
            data.reasons = { otherReasons: otherReasons, ...data.reasons };
        }
        requests.post('/appointments/notifications/email', data)
            .then(() => {
                const formattedDate = moment().format('DD/MM/YYYY [à] HH[h]mm');
                sendDataRaise(formattedDate, appointmentId, modalType);
            })
            .catch(error => {
                if (error.request.status === 401) {
                    window.location.replace('/guest/login');
                }
                throw error;
            });

        setOpen(!open);
        setOtherReason('');
        setSelectedDocuments([]);
        setSelectedStatus(null);
    };

    const toggle = () => {
        setOpen(!open);
    };

    const openModal = (type) => {
        setModalType(type);
        setOpen(!open);
    };


    const handleCheckboxChange = (statusChoice) => {
        if (selectedDocuments.includes(statusChoice)) {
            setSelectedDocuments(selectedDocuments.filter((status) => status !== statusChoice));
        } else {
            setSelectedDocuments([...selectedDocuments, statusChoice]);
        }
    };

    const handleLabelInputChange = (e) => {
        setOtherReason(e.target.value);
    };

    const handleRadioChange = (status) => {
        setSelectedStatus(status);
    };

    const renderModalContent = () => {
        if (modalType === modalChoice.MAIL) {
            return (
                <div>
                    <ModalHeader className="display-center"> Relance par mail </ModalHeader>
                    <ModalBody className="display-center">
                        {status.listInModal().map((statusItem) => (
                            <FormRadio
                                key = { statusItem.value }
                                value = { statusItem.value }
                                checked = { selectedStatus === statusItem.value }
                                onChange = { () => handleRadioChange(statusItem.value) }
                            >
                                {statusItem.label}
                            </FormRadio>
                        ))}
                        <label> Autres </label>
                        <FormTextarea
                            value={ otherReason }
                            onChange={ handleLabelInputChange }
                            placeholder="Saisir la raison de la relance"
                        />
                        <Button onClick={ handleSubmit} className = { "mt-2" }> Envoyer </Button>
                    </ModalBody>
                </div>
            );
        }
        if (modalType === modalChoice.PHONE && allowAccess) {
            return (
                <div>
                    <ModalHeader className="display-center"> Relance par téléphone/email </ModalHeader>
                    <ModalBody className="display-center">
                        <div>
                            <span className="font-weight-bold"> PRATICIEN </span> <br/> { practitioner ? practitioner.last_name && practitioner.first_name : 'non définie' }
                            <br/>
                            <i className="fas fa-phone"></i>
                            <span> { practitioner ? practitioner.practice_phone : 'non définie' } </span>
                            <br/>
                            <i className="fas fa-at"></i>
                            <span> { practitioner ? practitioner.email : 'non définie' } </span>
                        </div>
                        <br/>
                        <div>
                            <span className="font-weight-bold"> PATIENT </span> <br/> { patient ? patient.last_name && patient.first_name : 'non définie' }
                            <br/>
                            <i className="fas fa-phone"></i>
                            <span> { patient ? patient.phone : 'non définie' } </span>
                            <br/>
                            <i className="fas fa-at"></i>
                            <span> { patient ? patient.email : 'non définie' } </span>
                        </div>
                        <Button onClick = { raiseByPhone } className = { "mt-2" }> Relancer </Button>
                    </ModalBody>
                </div>
            );
        }
        if (modalType === modalChoice.FOLDER) {
            return (
                <div>
                    <ModalHeader className = "display-center"> Documents demandés par le patient </ModalHeader>
                    <ModalBody className = "display-center">
                        { missingDocuments.list().map((document) => (
                            <FormCheckbox
                                key = { document.value }
                                value = { document.value }
                                checked = { selectedDocuments.includes(document.value) }
                                onChange = { () => handleCheckboxChange(document.value) }
                            >
                                { document.label }
                            </FormCheckbox>
                        ))}
                        <label> Autres </label>
                        <FormTextarea
                            value = { otherReason }
                            onChange = { handleLabelInputChange }
                            placeholder = "Saisir la raison de la relance"
                        />
                        <Button onClick = { handleSubmit } className = {  "mt-2" }> Envoyer </Button>
                    </ModalBody>
                </div>
            );
        }
        return null;
    };

    const rowRaise = rowRaisedDoneSaved.find(data => data.id === appointmentId);

    return (
        <div>
            <div>
                <span className = "top-nav mr-2" onClick = { () => openModal(modalChoice.MAIL) }>
                    <i className = "far fa-envelope" style = { generateIconStyles(rowRaise && rowRaise.modalChoice === modalChoice.MAIL, '1.2rem', 'red') }></i>
                </span>
                <span className="top-nav mr-2" onClick = { () => openModal(modalChoice.PHONE) }>
                    <i className="far fa-address-card" style = { generateIconStyles(rowRaise && rowRaise.modalChoice === modalChoice.PHONE, '1.2rem', 'red') }></i>
                </span>
                <span className = "top-nav" onClick = { () => openModal(modalChoice.FOLDER) }>
                    <i className = "far fa-folder" style = { generateIconStyles(rowRaise && rowRaise.modalChoice === modalChoice.FOLDER, '1.2rem', 'red') }></i>
                </span>
                <Modal open = { open } toggle = { toggle } centered = { true }>
                    { renderModalContent() }
                </Modal>
            </div>
        </div>
    );
};

export default ModalNotifications;


// WEBPACK FOOTER //
// ./src/views/Dashboardlive/AppointmentsTable/ModalNotifications.js